__turbopack_context__.v({
  "arrow-down": "styles-module-scss-module__ynzKDW__arrow-down",
  "bottom": "styles-module-scss-module__ynzKDW__bottom",
  "chairs-container": "styles-module-scss-module__ynzKDW__chairs-container",
  "divider": "styles-module-scss-module__ynzKDW__divider",
  "header": "styles-module-scss-module__ynzKDW__header",
  "inner-container": "styles-module-scss-module__ynzKDW__inner-container",
  "numbers": "styles-module-scss-module__ynzKDW__numbers",
  "outer-container": "styles-module-scss-module__ynzKDW__outer-container",
  "stack": "styles-module-scss-module__ynzKDW__stack",
  "words": "styles-module-scss-module__ynzKDW__words",
});
